import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import {createBootstrap} from 'bootstrap-vue-next'
import store from './store'
import i18n from './i18n'
import moment from 'moment-timezone'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

moment.tz.setDefault('Europe/Amsterdam')

const app = createApp(App)

app.config.globalProperties.$filters = {
  currency(value) {
    return '€ ' + parseFloat(value).toLocaleString('nl-NL', { minimumFractionDigits: 2 })
  },
  time_format(value) {
    return moment(value).format('HH:mm')
  },
  date_time(value) {
    return moment(value).format('DD-MM-YYYY HH:mm')
  },
  date_written(value) {
    return moment(value).format('ddd D MMMM YYYY')
  },
  date_full(value) {
    return moment(value).format('dddd D MMMM YYYY HH:mm')
  }
}

app.use(createBootstrap())
app.use(router)
app.use(store)
app.use(i18n)
app.component('v-select', vSelect)
app.mount('#app')